import { useEffect, useState } from "react"
import { useNavigate } from 'react-router-dom';
import SoundsUtil from '../../utils/sounds';
import {isMobile} from '../../utils/viewport';

export default ({isAuth}) => {
    const navigate = useNavigate();

    const [state, setState] = useState({
        initialized: false,
        video: false,
        clicked: false
    });

    const assetsLoadedHandler = e => {
        setState({
            ...state,
            video: isMobile() ? false : true
        });
    }

    const loaderClickHandler = e => {
        if(state.clicked)
            return;

        setState({
            ...state,
            clicked: true
        });

        if(state.video) {
            const video = document.getElementById('background-video');
                  video.play();
        }

        SoundsUtil.toggle(null);
        // SoundsUtil.click();

        const ground = document.querySelector('.background .ground');
              ground.classList.add('animate__slideOutDown');

        const loader = document.querySelector('.screen.loader');
              loader.classList.add('animate__zoomOut');

        setTimeout(() => {
            loader.remove();
            navigate(isAuth ? '/home' : '/login');
        }, 1e3);
    }

    useEffect(() => {
        if(!state.initialized) {
            window.addEventListener('assets.loaded', assetsLoadedHandler);
            window.addEventListener('loader.click', loaderClickHandler);
            setState({...state, initialized: true});
        }
    }, [state.initialized])

    return (
        <div className="background">
            <div className="overlay"></div>       
            <div className="ground animate__animated animate__slow"></div>
            <div className={`main-bg ${state.video ? 'video' : ''}`}>
                {state.video && (
                    <video id="background-video" loop playsInline>
                        <source src={`${window.location.origin}/source/video/background.mp4`}></source>
                    </video>
                )}    
            </div>      
        </div>
    )
}